import { render, staticRenderFns } from "./PortraitProps.vue?vue&type=template&id=7f8ec7aa&scoped=true&"
import script from "./PortraitProps.vue?vue&type=script&lang=js&"
export * from "./PortraitProps.vue?vue&type=script&lang=js&"
import style0 from "./PortraitProps.vue?vue&type=style&index=0&id=7f8ec7aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ec7aa",
  null
  
)

export default component.exports